export default __webpack_public_path__ + "static/media/4.ce73e3a1.png";